import { Phone } from 'lucide-react';

import logoLarge from '@/assets/logo_large.png';
import { Button } from '@/components/ui/button.tsx';
import { SUPPORT_PHONE_DISPLAY, SUPPORT_PHONE_E164 } from '@/lib/constants';
import { cn } from '@/lib/utils';

interface AppHeaderProps {
  withShadow?: boolean;
}

export function AppHeader({ withShadow = true }: AppHeaderProps) {
  return (
    <header
      className={cn(
        'mb-4 flex items-center justify-between gap-2 p-4 sm:mb-7 sm:px-10 sm:py-5',
        withShadow && 'sm:shadow-[0_0_4px_0_rgba(0,0,0,0.04),0_4px_8px_0_rgba(0,0,0,0.06)]'
      )}
    >
      <img src={logoLarge} className="logo h-6.5 w-auto" alt="Conduit Health logo" />
      <Button variant="outline" size="sm" asChild className="bg-transparent no-underline">
        <a href={`tel:${SUPPORT_PHONE_E164}`}>
          <Phone className="fill-main" />
          {SUPPORT_PHONE_DISPLAY}
        </a>
      </Button>
    </header>
  );
}
